export default "__VITE_ASSET__RrTE99A5__"